import { axios } from '../../../../lib'
import { UserResponse } from '../types'

export type LoginCredentialsDTO = {
  username: string
  password: string
}

export const loginWithUsernameAndPassword = (
  data: LoginCredentialsDTO
): Promise<UserResponse> => {
  return axios.post('/authentication/login', data)
}
